// extracted by mini-css-extract-plugin
export default {"options-per-set":"OptionsPerSet_options-per-set__WACIv"};